<script>
import BaseIcon from './Icon.vue';
import iconsV2 from './dashboard-icons-v2.json';
import iconsV1 from './dashboard-icons.json';

export default {
  name: 'FluentIconV2',
  components: {
    BaseIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    iconLib: {
      type: String,
      default: 'fluent',
    },
  },
  data() {
    return {
      icons: { ...iconsV1, ...iconsV2 },
    };
  },
};
</script>

<template>
  <BaseIcon
    :size="size"
    :icon="icon"
    :type="type"
    :icons="icons"
    :view-box="viewBox"
    :icon-lib="iconLib"
  />
</template>
